import { createContext, type PropsWithChildren, useContext } from "react"

import type { ConfigLocal } from "@/services/dexie"

import { Theme } from "./types"

// TODO: tohle je duplikované na BE a na FE - je třeba vymyslet hezké sdílení schemat, typů a enumů mezi BE a FE
const defaultTheme: Theme = {
  fonts: {
    body: "'Open Sans', sans-serif",
    heading: "'Open Sans', sans-serif",
  },
  iconPack: "default3d",
  iconPackMotorcycle: "motorcycleDefault",
  colors: {
    primary: "#15BBEE",
    onPrimary: "#FFFFFF",
    background: "#FFFFFF",
    overlay: "rgba(27, 26, 28, 0.36)",
    heading: "#1B1A1C",
    text: "#696969",
    textMuted: "#678C9E",
    border: "#C5D3D6",
    error: "#E72E7D",
  },
  borderRadius: "99999px",
  logoUrl: "https://public.instacover.ai/logos/InstaClaim.svg",
}

export function resolveTheme(config: Pick<ConfigLocal, "theme" | "logoUrl">): Theme {
  return {
    ...defaultTheme,
    ...config.theme,
    colors: { ...defaultTheme.colors, ...config.theme.colors },
    logoUrl: config.logoUrl,
  }
}

// Theme values still needed in JS (iconPack switching, logoUrl, Lottie recolor, Konva strokes).
// Colors and fonts reach CSS through injectThemeVariables, not through this context.
const ThemeContext = createContext<Theme>(defaultTheme)

type ThemeProviderProps = {
  theme: Theme
}

export function ThemeProvider(props: PropsWithChildren<ThemeProviderProps>) {
  const { theme, children } = props

  return <ThemeContext.Provider value={theme}>{children}</ThemeContext.Provider>
}

export function useTheme() {
  const activeTheme = useContext(ThemeContext)

  return { activeTheme }
}
